const FEATURE = 'Referrals';

export const viewReferralsProperties = () => {
  return {
    feature: FEATURE,
    pageTitle: 'Referrals',
  };
};

export const clickReferButtonProperties = () => {
  return {
    action: 'click_refer_button',
    feature: FEATURE,
  };
};

export const clickCopyLinkProperties = (referralLink: string) => {
  return {
    action: 'copy_referral_link',
    feature: FEATURE,
    referralLink,
  };
};

export const clickShareLinkProperties = (shareMethod: 'mobile' | 'desktop') => {
  return {
    action: 'click_share_link',
    feature: FEATURE,
    shareMethod,
  };
};

export const sendReferralEmailProperties = (
  success: boolean,
  errorType?: string
) => {
  return {
    action: 'send_referral_email',
    errorType,
    feature: FEATURE,
    success,
  };
};

export const clickQrCodeProperties = () => {
  return {
    action: 'click_qr_code',
    feature: FEATURE,
  };
};

export const viewQrCodeModalProperties = () => {
  return {
    action: 'view_qr_code_modal',
    feature: FEATURE,
  };
};

export const clickLearnMoreProperties = (linkUrl: string) => {
  return {
    action: 'click_learn_more',
    feature: FEATURE,
    linkUrl,
  };
};
